import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';


export function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'ar' ? 'en' : 'ar';
    i18n.changeLanguage(newLang);
  };

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggleLanguage}
      data-testid="button-language-toggle"
    >
      {i18n.language === 'ar' ? 'ENG' : 'عربي'}
    </Button>
  );
}
